import type { ReactNode } from "react"
import { create } from "zustand"

// Icon types as an enum for better type safety
export type ModalIconType = "success" | "error" | "warning" | "info"

// Core modal content interface
export interface ModalContent {
  title?: string
  message?: string | ReactNode
  icon?: ReactNode
  cover?: string
  children?: ReactNode
}

// Button configuration interface
export interface ModalActions {
  primaryLabel?: string
  secondaryLabel?: string
  onPrimaryAction?: () => void
  onSecondaryAction?: () => void
  buttonOrientation?: "vertical" | "horizontal"
}

// Modal behavior configuration
export interface ModalBehavior {
  closeOnMaskClick?: boolean
  showCloseButton?: boolean
  iconType?: ModalIconType
  maskClosable?: boolean
  cancelable?: boolean
}

// Combined modal props interface
export interface ModalProps extends ModalContent, ModalActions, ModalBehavior {}

interface ModalStore {
  show: boolean
  data?: ModalProps
  open: (data: ModalProps) => void
  close: () => void
}

const useModalStore = create<ModalStore>((set) => ({
  show: false,
  open: (data: ModalProps) =>
    set({
      show: true,
      data: {
        ...data,
        closeOnMaskClick: data.closeOnMaskClick ?? data.maskClosable,
        showCloseButton: data.showCloseButton ?? data.cancelable,
      },
    }),
  close: () => set({ show: false }),
}))

export { useModalStore }
